<template>
  <div
    v-if="showLoadingState < 3"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="billingMyCharges"
  >

    <div class="align-items-baseline display-flex-row">
      <form
        autocomplete="off"
        class="m-form-row m-form-search"
        name="simple-filters-form"
        @submit.prevent="searchSimpleFilter"
      >
        <AtomInputPrimary
            v-model="simpleFilter.academia_url"
            :disabled="pagination.showLoadingState"
            v-on:keyup.enter="searchSimpleFilter"
            name="academiaUrl"
            placeholder="url de la academia"
            type="text"
            wrapperClass="a-input-wrapper-row"
        />
        <AtomSelectPrimary
          v-model.number="simpleFilter.estado"
          :disabled="pagination.showLoadingState"
          :elements="[...$filters.parameters.paymentsStates].filter(s => s.id !== 5)"
          keyField="id"
          name="estado"
          textField="name"
          wrapperClass="a-input-wrapper-row"
          @change="searchSimpleFilter"
        />
        <AtomSelectPrimary
          v-model.number="simpleFilter.divisa"
          :disabled="pagination.showLoadingState"
          :elements="divisas"
          keyField="id_divisa"
          name="divisas"
          textField="nombre"
          wrapperClass="a-input-wrapper-row"
          @change="searchSimpleFilter"
        />
        <AtomSelectPrimary
          v-model.number="simpleFilter.periodo"
          :disabled="pagination.showLoadingState"
          :elements="$filters.parameters.periods"
          keyField="id"
          name="periodo"
          textField="name"
          wrapperClass="a-input-wrapper-row"
          @change="searchSimpleFilter"
        />
        <AtomButtonSecondary
          :button-secondary="buttonSecondary.reset"
          :disabled="pagination.showLoadingState"
          @reloadListing="reloadListing"
        />
      </form>

      <div class="m-dropdown-primary">
        <AtomButtonSecondary
          :button-secondary="buttonSecondary.filter"
          :disabled="pagination.showLoadingState"
          @switchDropDown="$dropDown.switchDropDown"
        />
        <MoleculeEditionBillingAcademyChargesDropDownFilters
          :academiaIdSeted="academia_id"
          :academiaUrlSeted="simpleFilter.academia_url"
          :filter-seted="filter"
          @reloadListing="reloadListing"
          @searchAdvancedFilter="searchAdvancedFilter"
        />
      </div>

      <div class="display-flex-row margin-left-auto">
        <AtomButtonSecondary
          v-show=false
          :button-secondary="buttonSecondary.payments"
          @goToInvoicesHistory="goToInvoicesHistory"
        />
        <form
          autocomplete="off"
          class="m-form-row"
          name="download-csv-form"
          @submit.prevent="readCobrosExportar"
        >
          <AtomButtonPrimary
            :button-primary="buttonPrimary"
            :disabled="pagination.showLoadingState || !cobros.length"
          />
        </form>
      </div>
    </div>

    <div class="m-table-primary">
      <table class="table-layout-fixed">
        <tr v-show="cobros.length">
          <th
            class="text-align-center"
            width="10%"
          >
            {{ $t('mEditionBillingAcademyCharges.table.thTotal') }}
          </th>
          <th
            class="text-align-center"
            width="10%"
          >
             {{ $t('mEditionBillingAcademyCharges.table.thDate') }}
          </th>
          <th
            class="text-align-center"
            width="10%"
          >
             {{ $t('mEditionBillingAcademyCharges.table.thDiscount') }}
          </th>
          <th
            class="text-align-center"
            width="15%"
          >
             {{ $t('mEditionBillingAcademyCharges.table.thMethod') }}
          </th>
          <th
            class="text-align-left"
            width="15%"
          >
             {{ $t('mEditionBillingAcademyCharges.table.thConcept') }}
          </th>
          <th
            class="text-align-left"
            width="20%"
          >
             {{ $t('mEditionBillingAcademyCharges.table.thClient') }}
          </th>
          <th
            class="text-align-center"
            width="15%"
          >
             {{ $t('mEditionBillingAcademyCharges.table.thToPay') }}
          </th>
          <th
            class="text-align-center"
            width="4%"
          >
             {{ $t('mEditionBillingAcademyCharges.table.thRecord') }}
          </th>
        </tr>
        <tr
          v-for="(cobro, index) in cobros"
          :key="index"
          class="row-data"
        >
          <td class="text-align-right text-white-space-nowrap">
            <a
              v-if="cobro.monto"
              class="sale-state"
              :href="`${$t('mEditionMenu.billing.academySales.subject')}/${cobro.id_venta}/${$t('mEditionMenu.billing.academySales.children.record.subedition')}`"
              target="_blank"
            >
              <span>{{ cobro.divisa }} {{ cobro.monto.toFixed(2) }}</span>
              <span class="text-color-black-35"> {{ cobro.divisa_iso_code }}</span><br>
              <small :class="$filters.getPaymentStateValue(cobro.pago_estado, 'class')">
                {{ $filters.getPaymentStateValue(cobro.pago_estado, 'name') }}
              </small>
            </a>
            <a
             v-else
              class="sale-state"
              :href="`${$t('mEditionMenu.billing.academySales.subject')}/${cobro.id_venta}/${$t('mEditionMenu.billing.academySales.children.record.subedition')}`"
              target="_blank"
            >
              <span>{{ $t('mEditionBillingAcademySales.free') }}</span><br>
              <small :class="$filters.getSaleStateValue(cobro.pago_estado, 'class')">
                {{ $filters.getSaleStateValue(cobro.pago_estado, 'name') }}
              </small>
            </a>
          </td>
          <td class="text-align-center text-transform-capitalize text-white-space-nowrap">
            {{ $moment.parseZone(cobro.fecha_pago).format('D MMM YYYY') }}
          </td>
          <td class="ellipsis text-align-center">
            <span
              v-if="cobro.cupon_codigo"
              :key="`${index}-${cobro.cupon_codigo}`"
            >
              {{ cobro.cupon_codigo }}
            </span>
            <span
              v-else
              :key="`${index}-nodiscount`"
            >
              -
            </span>
          </td>
          <td class="text-align-center">
            <span v-if="cobro.medio_pago">
              {{ cobro.medio_pago }}
            </span>
            <span v-else>
              -
            </span>
          </td>
          <td class="break-word text-align-left">
            {{ cobro.concepto_pago }}
          </td>
          <td class="break-word text-align-left">
            <span class="display-flex-column">
              <span>{{ cobro.nombre_cliente }}</span>
              <small class="ellipsis font-weight-regular text-color-black-35">
                {{ cobro.email_cliente }}
              </small>
            </span>
          </td>
          <td class="text-align-center">
            {{
              cobro.monto
                ? $utils.getPaymentFrequency(cobro.pago_cuotas, cobro.pago_frecuencia, cobro.pago_intervalo)
                : '-'
            }}
          </td>
          <td class="text-align-center">
            <a
              :href="`${$t('mEditionMenu.billing.academySales.subject')}/${cobro.id_venta}/${$t('mEditionMenu.billing.academySales.children.record.subedition')}`"
              class="a-button-no-border a-button-secondary a-button-billing-secondary a-button-icon-rounded align-items-center justify-content-center"
              target="_blank"
            >
              <i class="far fa-file-alt"></i>
            </a>
          </td>
        </tr>
      </table>
      <MoleculePaginationPrimary
        :pagination="pagination"
        @setPaginationCurrentPage="setPaginationCurrentPage"
      />
    </div>
  </div>
</template>

<script>
import configApp from '@/config'

export default {
  name: 'MoleculeEditionBillingAcademyCharges',

  components: {
    MoleculeEditionBillingAcademyChargesDropDownFilters: () => import('@/components/molecules/MoleculeEditionBillingAcademyChargesDropDownFilters'),
    MoleculePaginationPrimary: () => import('@/components/molecules/MoleculePaginationPrimary')
  },

  data () {
    return {
      academia_id: '',

      buttonIconRounded: {
        record: {
          class: 'a-button-secondary a-button-billing-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'far fa-file-alt',
          method: 'gotToSaleRecord',
          tooltip: 'Ver Venta',
          type: 'button'
        }
      },

      buttonPrimary: {
        action: this.$t('mEditionBillingAcademySales.buttonPrimary'),
        behavior: 'download',
        class: 'a-button-primary a-button-billing-primary',
        sending: false,
        type: 'submit'
      },

      buttonSecondary: {
        filter: {
          class: 'a-button-secondary a-button-billing-secondary',
          component: 'MoleculeEditionBillingAcademyChargesDropDownFilters',
          icon: 'fas fa-filter',
          method: 'switchDropDown',
          text: this.$t('mEditionBillingAcademySales.buttonSecondary.filterText'),
          type: 'button'
        },

        payments: {
          class: 'a-button-secondary a-button-billing-secondary a-button-side a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'fas fa-file-alt',
          method: 'goToInvoicesHistory',
          text: '',
          tooltip: 'Ver Comprobantes',
          type: 'button'
        },

        reset: {
          class: 'a-button-secondary a-button-billing-secondary a-button-side a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'fas fa-sync-alt',
          method: 'reloadListing',
          text: '',
          tooltip: this.$t('mEditionBillingAcademySales.tooltip.restart'),
          type: 'button'
        }
      },

      cobros: [],
      divisas: [{
        id_divisa: '',
        nombre: 'Todas la divisas'
      }
      ],

      filter: {
        buscar: '',
        cupon: '',
        divisa: [],
        estado: [],
        fecha_desde: '',
        fecha_hasta: '',
        limite: 10,
        pagina: 1,
        pais: '',
        pasarela_pago: [],
        producto: [],
        tipo_producto: ''
      },

      pagination: {
        currentPage: 1,
        currentQuantity: 0,
        limit: 10,
        showLoadingState: false,
        totalPages: 0,
        totalQuantity: 0
      },

      showLoadingState: 0,

      simpleFilter: {
        academia_url: '',
        divisa: '',
        estado: '',
        periodo: 0
      }
    }
  },

  created () {
    this.resetSimpleFilter()
    this.searchSimpleFilter()
    this.readDivisas()
  },

  watch: {
    'simpleFilter.divisa' () {
      if (this.simpleFilter.divisa !== '') {
        this.filter.divisa = []
        this.filter.divisa[0] = this.simpleFilter.divisa
      } else {
        this.filter.divisa = []
      }
    },

    'simpleFilter.estado' () {
      if (this.simpleFilter.estado !== '') {
        this.filter.estado = []
        this.filter.estado[0] = this.simpleFilter.estado
      } else {
        this.filter.estado = []
      }
    },

    'simpleFilter.periodo' () {
      if (this.simpleFilter.periodo === '') {
        if (!(this.filter.fecha_desde !== '' || this.filter.fecha_hasta !== '')) {
          this.simpleFilter.periodo = 0
        }
      }

      if (this.simpleFilter.periodo !== '') {
        this.filter.fecha_desde = this.$filters.parameters.periods[this.simpleFilter.periodo].dateFrom
        this.filter.fecha_hasta = this.$filters.parameters.periods[this.simpleFilter.periodo].dateTo
      }
    }
  },

  methods: {
    goToInvoicesHistory () {
      this.$router.push(`/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.academySales.subject')}/${this.$t('mEditionMenu.billing.academySales.children.invoicesHistory.subedition')}`)
    },

    readAcademia () {
      if (!this.pagination.showLoadingState) {
        this.pagination.showLoadingState = true
        this.$services.read('academia', 'readAcademiaUrl', {}, [this.simpleFilter.academia_url])
          .then(response => {
            this.academia_id = response.data.id
            this.readCobros()
            this.showLoadingState++
          })
          .catch(error => {
            this.$alerts.pushAlert('mEditionBillingAcademyCharges', 'readCobros', 'error', 'a-alert-danger')
            this.cobros = []
            this.pagination.currentQuantity = 0
            this.pagination.totalPages = 0
            this.pagination.totalQuantity = 0
            this.showLoadingState+= 2
            this.pagination.showLoadingState = false
            console.log(error)
          })
      }
    },

    readCobros () {
      this.$services.read('ventas', 'readVentasMisCobros', {}, [this.academia_id], this.filter)
        .then(response => {
          this.cobros = response.data.cobros
          this.showLoadingState++
          this.pagination.currentQuantity = this.cobros.length
          this.pagination.totalPages = response.data.pages
          this.pagination.totalQuantity = response.data.total
          this.pagination.showLoadingState = false
        })
        .catch(error => {
          console.log(error)
          this.cobros = []
          this.pagination.currentQuantity = 0
          this.pagination.totalPages = 0
          this.pagination.totalQuantity = 0
          this.pagination.showLoadingState = false
          this.showLoadingState++
        })
    },

    readDivisas () {
      this.$services.read('divisa', 'readDivisas')
        .then(response => {
          this.divisas = [...this.divisas, ...response.data]
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState = 0
        })
    },

    readCobrosExportar () {
      if (!this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.read('ventas', 'readVentasMisCobrosExportar', {}, [this.academia_id], this.filter)
          .then(response => {
            this.$files.downloadCsv(response.data, `${this.$t('mEditionBillingAcademyCharges.files.charges')}-${this.$moment().format('YYYYMMDD')}`)
            this.buttonPrimary.sending = false
            this.$alerts.pushAlert('mEditionBillingAcademyCharges', 'readCobrosExportar', 'success', 'a-alert-success')
          })
          .catch(error => {
            console.log(error)
            this.buttonPrimary.sending = false
            this.$alerts.pushAlert('mEditionBillingAcademyCharges', 'readCobrosExportar', 'error', 'a-alert-danger')
          })
      }
    },

    reloadListing () {
      this.resetSimpleFilter()
      this.resetAdvancedFilter()
      this.setPaginationCurrentPage(1)
    },

    resetAdvancedFilter () {
      this.filter = {
        buscar: '',
        cupon: '',
        divisa: [],
        estado: [],
        fecha_desde: '',
        fecha_hasta: '',
        limite: 10,
        pagina: 1,
        pais: '',
        pasarela_pago: [],
        producto: [],
        tipo_producto: ''
      }
    },

    resetSimpleFilter () {
      this.simpleFilter = {
        academia_url: this.simpleFilter.academia_url ? this.simpleFilter.academia_url : configApp.academyUrl,
        divisa: '',
        estado: '',
        periodo: 0
      }
    },

    searchAdvancedFilter (advancedFilter, academiaUrl) {
      this.filter = Object.assign({}, advancedFilter)
      let fecha_desde = this.$filters.parameters.periods[this.simpleFilter.periodo] ? this.$filters.parameters.periods[this.simpleFilter.periodo].dateFrom : ''
      let fecha_hasta = this.$filters.parameters.periods[this.simpleFilter.periodo] ? this.$filters.parameters.periods[this.simpleFilter.periodo].dateTo : ''

      if (!(this.filter.fecha_desde === fecha_desde && this.filter.fecha_hasta === fecha_hasta)) {
        this.simpleFilter.periodo = ''
      }
      this.simpleFilter.academia_url = academiaUrl
      this.setPaginationCurrentPage(1)
    },

    searchSimpleFilter () {
      this.setPaginationCurrentPage(1)
    },

    setPaginationCurrentPage (page) {
      this.filter.pagina = page
      this.pagination.currentPage = page
      this.readAcademia()
    }
  }
}
</script>
